import React, { useEffect } from "react";
import Footer from "../../shared/Footer/Footer";
import Navbar from "../../shared/Navbar/Navbar";
import "../../../style/about/motoAndValues.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowDownLong,
  faArrowRight,
  faArrowRightLong,
  faHandHoldingHeart,
  faHandsHoldingCircle,
} from "@fortawesome/free-solid-svg-icons";
import TranslateButton from "../../TranslateButton/TranslateButton";
import {
  FacebookIcon,
  FacebookShareButton,
  TwitterShareButton,
  TwitterIcon,
  LinkedinShareButton,
  LinkedinIcon,
} from "react-share";

const MotoAndValues = () => {
  useEffect(() => {
    document.title = `Development Concern | Moto and Values`;
  }, []);

  // const shareUrl = "https://developmentconcerncht.org/about/moto-and-values";

  return (
    <>
      <Navbar />
      {/* <TranslateButton /> */}

      <div className="moto_and_values_section">
        <div className="header_image">
          <p>Home | About</p>
          <h2>Motto & Core Values</h2>
        </div>

        {/* Header Background Part Start */}
        {/* <div className="header_background">
          <div className="container wrapper">
            <h2>Motto And Core Values</h2>
            <div className="social_share_button">
              <FacebookShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share facebook"}
                hashtag={"#facebook"}
              >
                <FacebookIcon size={35} round={true} />
              </FacebookShareButton>
              <TwitterShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share twitter"}
                hashtag={"#twitter"}
              >
                <TwitterIcon size={35} round={true} />
              </TwitterShareButton>
              <LinkedinShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share linkedin"}
                hashtag={"#linkedin"}
              >
                <LinkedinIcon size={35} round={true} />
              </LinkedinShareButton>
            </div>
          </div>
        </div> */}
        {/* Header Background Part End */}
        <div className="motto_and_values_wrapper">
          <h1>Motto and Core Values</h1>
          <div className="motto_wrapper">
            <div className="container">
              <div className="moto_section">
                <h3>Our Motto</h3>
                <p>DC’s mandate is to end poverty, build democratic governance, rule of law, and inclusive institutions. We advocate for change, and connect countries to knowledge, experience and resources to help people build a better life.</p>
              </div>
            </div>
          </div>

          <div className="values_wrapper">
            <div className="container">
              <h3>Core Values</h3>
              <p>Inclusiveness </p>
              <p>Transparency and accountability</p>
              <p>Community participation </p>
              <p>Sustainability </p>
              <p> Respect for cultural diversity and indigenous identity</p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default MotoAndValues;
